export function getWindflowServerBaseUrl() {
    return "https://api.lumindigitaltech.com/windflow"
}

export function getPyServerBaseUrl() {
    return "https://api.lumindigitaltech.com/pyservice"
}